import prism from 'prismjs';
import './themes/prism.module.css';

export const getPrism = () => {
  return prism;
};
